import { render, staticRenderFns } from "./WriteOff.vue?vue&type=template&id=7bb9b2b6&scoped=true"
import script from "./WriteOff.vue?vue&type=script&lang=js"
export * from "./WriteOff.vue?vue&type=script&lang=js"
import style0 from "./WriteOff.vue?vue&type=style&index=0&id=7bb9b2b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb9b2b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb9b2b6')) {
      api.createRecord('7bb9b2b6', component.options)
    } else {
      api.reload('7bb9b2b6', component.options)
    }
    module.hot.accept("./WriteOff.vue?vue&type=template&id=7bb9b2b6&scoped=true", function () {
      api.rerender('7bb9b2b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/components/WriteOff.vue"
export default component.exports